"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesUnknownIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><path fill="inherit" d="M12 11h3.502a.5.5 0 0 1 .498.491v4.518A.993.993 0 0 1 15 17H9.01C8.451 17 8 16.544 8 16.005v-8.01C8 7.445 8.443 7 9.01 7h2.5a.5.5 0 0 1 .49.51zm1-4 3 3h-3z"/></g></svg>`
}, props));
MediaServicesUnknownIcon.displayName = 'MediaServicesUnknownIcon';
var _default = exports.default = MediaServicesUnknownIcon;